module.exports = __webpack_public_path__ + "static/media/taste-test-iphone-1.d6cddc8a.png";